import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './Diary.styles';
import IDiaryProperties from './Diary.properties';
import { ActionBarContext } from 'utils/ActionBarContextProvider';
import DiaryGrid from './DiaryGrid';
import { BACK_BUTTON } from 'components/common/ActionBar/constants';
import { AddCircle as AddIcon } from '@markinson/uicomponents-v2/SvgIcons/';

const Diary = (props: IDiaryProperties) => {
    const {
        classes,
        module,
        gridProps
    } = props;

    const { setActionBar } = React.useContext(ActionBarContext);

    const isDisabled = React.useMemo(
        () => {
            if (module?.name === 'PurchaseOrders') {

                return !module?.selectedItem || module?.summaryDetails?.Status?.toLowerCase() === 'complete';
            }

            if (module?.name === 'PickSlips') {

                return !Number(module?.selectedItem);
            }

            return false;
        },
        [module?.name, module?.selectedItem, module?.summaryDetails?.Status]
    );

    React.useEffect(
        () => {
            setActionBar({
                leftIcons: [BACK_BUTTON],
                centerIcons: [],
                rightIcons: [
                    {
                        label: 'New',
                        Icon: AddIcon,
                        disabled: isDisabled,
                        action: 'AddDiary',
                    }]
            });

        },
        [isDisabled]
    );

    return (
        <div className={classes.container}>
            <DiaryGrid
                {...gridProps}
                module={{
                    name: module?.name,
                    tableId: module?.tableId,
                    selectedItem: module?.selectedItem,
                    summaryDetails: module?.summaryDetails,
                    entity: module?.entity
                }}
                navigateBack={props.navigateBack}
            />
        </div>
    );
};

export default withStyles(styles, { index: 1 })(Diary);
